var map = {
	"./bg.json": 1401,
	"./bs.json": 8797,
	"./ca.json": 3010,
	"./cnr.json": 8167,
	"./cs.json": 8432,
	"./cy.json": 3802,
	"./da.json": 6149,
	"./de.json": 1873,
	"./el.json": 2539,
	"./en.json": 8053,
	"./es.json": 1406,
	"./et.json": 7123,
	"./eu.json": 9600,
	"./fi.json": 4431,
	"./fr.json": 7222,
	"./ga.json": 4150,
	"./gl.json": 7197,
	"./hr.json": 4956,
	"./hu.json": 5837,
	"./is.json": 4786,
	"./it.json": 8767,
	"./lb.json": 1040,
	"./lt.json": 5134,
	"./lv.json": 4316,
	"./mk.json": 798,
	"./mt.json": 6091,
	"./nb.json": 9070,
	"./nl.json": 8920,
	"./pl.json": 6690,
	"./pt.json": 5034,
	"./ro.json": 5489,
	"./ru.json": 8335,
	"./sk.json": 3272,
	"./sl.json": 6817,
	"./sq.json": 1026,
	"./sr.json": 5731,
	"./sv.json": 2991,
	"./tr.json": 2584,
	"./uk.json": 230
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2815;